'use strict';

module.exports = darc.compile({
	id: darc.types.primary(String),
	country: String,
	currency: String
});

module.exports.Set = darc.compile(darc.types.set(module.exports.schema));
